export const initialState = {
  location: null,
  isAuthCheckComplete: false,
  isOneTrustInitialized: null,
  isEcommercePage: false,
  isAccountConfirmed: false,
  isAccountConfirmationRequired: false,
  isAccountChangeRequested: false,
  locale: "en",
  isCartInitialized: false,
  cart: null,
  accountId: undefined,
  activeAccount: null,
  accounts: undefined,
  isAccountsLoading: undefined,
  currency: undefined,
  countryCode: null,
}

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_AUTH_CHECK_COMPLETE":
      return {
        ...state,
        isAuthCheckComplete: action.payload,
      }
    case "SET_LOCATION":
      return {
        ...state,
        location: action.payload,
      }
    case "ONE_TRUST_INITIALIZED":
      return {
        ...state,
        isOneTrustInitialized: true,
      }
    case "SET_LOCALE":
      return {
        ...state,
        locale: action.payload.locale,
      }
    case "SET_CART_INITIALIZED":
      return {
        ...state,
        isCartInitialized: action.payload,
      }
    case "UPDATE_CART":
      return {
        ...state,
        cart: action.payload,
      }
    case "SET_ACCOUNTS_LOADING":
      return {
        ...state,
        isAccountsLoading: action.payload,
      }
    case "SET_ACCOUNTS":
      return {
        ...state,
        accounts: action.payload,
      }
    case "PATCH_ACCOUNTS":
      const newAccounts = state?.accounts.map(account => {
        if (action.payload.id === account.id) {
          return action.payload
        }
        return account
      })      
      return {
        ...state,
        accounts: newAccounts,
      }      
    case "SET_ACCOUNT_ID":
      return {
        ...state,
        accountId: action.payload,
      }
    case "SET_ACTIVE_ACCOUNT":
      return {
        ...state,
        activeAccount: action.payload,
      }
    case "SET_ACCOUNT_CONFIRMED":
      return {
        ...state,
        isAccountConfirmed: action.payload,
      }
    case "SET_ACCOUNT_CONFIRMATION_REQUIRED":
      return {
        ...state,
        isAccountConfirmationRequired: action.payload,
      }
    case "SET_ACCOUNT_CHANGE_REQUESTED":
      return {
        ...state,
        isAccountChangeRequested: action.payload,
      }      
    case "SET_ECOMMERCE_PAGE":
      return {
        ...state,
        isEcommercePage: action.payload,
      }      
    case "SET_CURRENCY":
      return {
        ...state,
        currency: action.payload,
      }
    case "SET_COUNTRY":
      return {
        ...state,
        countryCode: action.payload,
      }      
    default:
      return state
  }
}
